import React from 'react';
import './ServicePhases.css';
import About1 from '../Componet/about1'
import About2 from '../Componet/about2'
import Ourteam from '../Componet/Ourteam' 


const OurWorks = () => {
  return (
    <>
    
    <About1/>
    <About2/>
    <Ourteam/>
      
    </>
  );
};

export default OurWorks;
